import React, { useRef, useEffect } from 'react';
import customerService from '../../services/customerService';
import supplierService from '../../services/supplierService';
import tailorService from '../../services/tailorService';
import cuttingMasterService from '../../services/cuttingmasterService';
import locationService from '../../services/locationService';
import itemService from '../../services/itemService';
import CommonInput from '../Common/CommonInput';
import CommonAsyncSelect from '../Common/CommonAsyncSelect';
import CommonSelect from '../Common/CommonSelect';
import useModal from '../../hooks/useModal';
import Customers from '../../pages/Customers/Customers';
import Suppliers from '../../pages/Suppliers/Suppliers';
import Tailors from '../../pages/Tailors/Tailors';
import Cuttingmasters from '../../pages/Cuttingmasters/Cuttingmasters';
import Locations from  '../../pages/Locations/Locations'
import Items from '../../pages/Items/Items';
import DataSelectionModal from '../Common/CommonModal/DataSelectionModal';


const ClassicFilter = ({ filters, handleClassicFilterChange, handleClassicFilterApply }) => {    
    const handleSelectChange = (name, value) => {
        handleClassicFilterChange(name, value);
    }

    const supplierModal = useModal();
    const supplierExternalCondition = {};
    const customerModal = useModal();
    const customerExternalCondition = {};
    const tailorModal = useModal();
    const tailorExternalCondition = {};
    const cuttingMasterModal = useModal();
    const cuttingMasterExternalCondition = {};
    const locationModal = useModal();
    const locationExternalCondition = {};
    const itemModal = useModal();
    const itemExternalCondition = {};
    
    const handleSupplierSelected = (supplier) => {
        handleSelectChange('supplier_id', {value: supplier.id, label: supplier.name?.en+' ('+supplier.supplier_code+')'});
        supplierModal.hide();
    };

    const handleCustomerSelected = (customer) => {
        handleSelectChange('customer_id', {value: customer.id, label: customer.name?.en+' ('+customer.customer_code+')'});
        customerModal.hide();
    };

    const handleTailorSelected = (tailor) => {
        handleSelectChange('tailor_id', {value: tailor.id, label: tailor.name?.en+' ('+tailor.employee_code+')'});
        tailorModal.hide();
    };

    const handleCuttingMasterSelected = (cuttingMaster) => {
        handleSelectChange('cutting_master_id', {value: cuttingMaster.id, label: cuttingMaster.name?.en+' ('+cuttingMaster.employee_code+')'});
        cuttingMasterModal.hide();
    };

    const handleLocationSelected = (location) => {
        handleSelectChange('location_id', {value: location.id, label: location.name?.en+' ('+location.location_number+')'});
        locationModal.hide();
    };

    const handleItemSelected = (selectedItems) => {
  
        const currentItems = filters?.item_id?.query?.value || [];
        
        // Filter out items that already exist in the form
        const newItems = selectedItems.filter(selectedItem => 
            !currentItems.some(existingItem => existingItem.item?.id === selectedItem.id)
        );

        handleSelectChange('item_id', {value: newItems.map(item => ({id: item.id, label: item.name?.en+' ('+item.item_code+')'}))});
        itemModal.hide();
    }

    const handleSelectDropdownChange = (name, value) => {

        if(!value) {
            handleSelectChange(name, {value: null, label: null})
            return;
        }
        handleSelectChange(name, {value: value.id, label: value.label})
    }

    const handleItemsSelectDropdownChange = (name, value) => {
        if(!value) {
            handleSelectChange(name, [])
            return;
        }
        handleSelectChange(name, {value: value.map(item => ({id: item.id, label: item.label}))});
    }

    const applyClassicFilter = () => {
        handleClassicFilterApply()
    }

    return (
        <div className="row">
            {
                filters.hasOwnProperty('order_number') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <CommonInput
                                    className="mb-0"
                                    name="order_number"
                                    label="Job No."
                                    value={filters?.order_number?.query?.value}
                                    onChange={(e) => handleSelectChange('order_number', {'value': e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
                        {
                filters.hasOwnProperty('lpo_number') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <CommonInput
                                    className="mb-0"
                                    name="lpo_number"
                                    label="LPO Number"
                                    value={filters?.lpo_number?.query?.value}
                                    onChange={(e) => handleSelectChange('lpo_number', {'value': e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('employee_name') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <CommonInput
                                    className="mb-0"
                                    name="employee_name"
                                    label="Employee Name"
                                    value={filters?.employee_name?.query?.value}
                                    onChange={(e) => handleSelectChange('employee_name', {'value': e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('customer_name') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <CommonInput
                                    className="mb-0"
                                    name="customer_name"
                                    label="Customer Name"
                                    value={filters?.customer_name?.query?.value}
                                    onChange={(e) => handleSelectChange('customer_name', {'value': e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('customer_phone') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <CommonInput
                                    className="mb-0"
                                    name="customer_phone"
                                    label="Customer Phone"
                                    value={filters?.customer_phone?.query?.value}
                                    onChange={(e) => handleSelectChange('customer_phone', {'value': e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('from_date') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">From Date</label>
                                <input type="date" className="form-control" value={filters?.from_date?.query?.value} onChange={(e) => handleSelectChange('from_date', {'value': e.target.value})}/>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('to_date') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">To Date</label>
                                <input type="date" className="form-control" value={filters?.to_date?.query?.value} onChange={(e) => handleSelectChange('to_date', {'value': e.target.value})}/>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('supplier_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{width: '220px'}}>
                        <CommonAsyncSelect
                            name="supplier"
                            label="Supplier"
                            className="w-100 d-flex flex-column"
                            value={{id: filters?.supplier_id?.query?.value, label: filters?.supplier_id?.query?.label}}
                            onChange={(value) => handleSelectDropdownChange('supplier_id', value)}
                            loadOptions={async (inputValue) => {
                                
                                const condition = {
                                    rules: {
                                        condition: 'and',
                                        children: []
                                    }
                                }
        
                                const response = await supplierService.getList({ search: inputValue }, condition);
                                return response.data.map(item => ({
                                    id: item.id,
                                    label: item.name?.en+' ('+item.supplier_code+')',
                                }));
                            }}
                            actionButtons={[
                                {
                                    icon: 'fa fa-bars',
                                    label: '',
                                    className: 'btn-primary',
                                    onClick: (value) => supplierModal.show()
                                }
                            ]}
                        />
                    </div>
                </div>
                ) : null
            }
            {
                filters.hasOwnProperty('customer_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{minWidth: '220px'}}>
                            <CommonAsyncSelect
                                name="customer"
                                label="Customer Code"
                                className="w-100 d-flex flex-column"
                                value={{id: filters?.customer_id?.query?.value, label: filters?.customer_id?.query?.label}}
                                onChange={(value) => handleSelectDropdownChange('customer_id', value)}
                                loadOptions={async (inputValue) => {
                                    
                                    const condition = {
                                        rules: {
                                            condition: 'and',
                                            children: []
                                        }
                                    }
            
                                    const response = await customerService.getList({ search: inputValue }, condition);
                                    return response.data.map(item => ({
                                        id: item.id,
                                        label: item.name?.en+' ('+item.customer_code+')',
                                    }));
                                }}
                                actionButtons={[
                                    {
                                        icon: 'fa fa-bars',
                                        label: '',
                                        className: 'btn-primary',
                                        onClick: (value) => customerModal.show()
                                    }
                                ]}
                            />
                        </div>
                    </div>
                    ) : null
            }
            {
                filters.hasOwnProperty('tailor_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{width: '220px'}}>
                        <CommonAsyncSelect
                            name="tailor"
                            label="Tailor"
                            className="w-100 d-flex flex-column"
                            value={{id: filters?.tailor_id?.query?.value, label: filters?.tailor_id?.query?.label}}
                            onChange={(value) => handleSelectDropdownChange('tailor_id', value)}
                            loadOptions={async (inputValue) => {
                                
                                const condition = {
                                    rules: {
                                        condition: 'and',
                                        children: []
                                    }
                                }
        
                                const response = await tailorService.getList({ search: inputValue }, condition);
                                return response.data.map(item => ({
                                    id: item.id,
                                    label: item.name?.en+' ('+item.employee_code+')',
                                }));
                            }}
                            actionButtons={[
                                {
                                    icon: 'fa fa-bars',
                                    label: '',
                                    className: 'btn-primary',
                                    onClick: (value) => tailorModal.show()
                                }
                            ]}
                        />
                    </div>
                </div>
                ) : null
            }
            {
                filters.hasOwnProperty('cutting_master_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{width: '220px'}}>
                        <CommonAsyncSelect
                            name="cutting_master"
                            label="Cutting Master"
                            className="w-100 d-flex flex-column"
                            value={{id: filters?.cutting_master_id?.query?.value, label: filters?.cutting_master_id?.query?.label}}
                            onChange={(value) => handleSelectDropdownChange('cutting_master_id', value)}
                            loadOptions={async (inputValue) => {
                                
                                const condition = {
                                    rules: {
                                        condition: 'and',
                                        children: []
                                    }
                                }
        
                                const response = await cuttingMasterService.getList({ search: inputValue }, condition);
                                return response.data.map(item => ({
                                    id: item.id,
                                    label: item.name?.en+' ('+item.employee_code+')',
                                }));
                            }}
                            actionButtons={[
                                {
                                    icon: 'fa fa-bars',
                                    label: '',
                                    className: 'btn-primary',
                                    onClick: (value) => cuttingMasterModal.show()
                                }
                            ]}
                        />
                    </div>
                </div>
                ) : null
            }
            {
                filters.hasOwnProperty('location_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{width: '220px'}}>
                            <CommonAsyncSelect
                                name="location"
                                label="Location"
                                className="w-100 d-flex flex-column"
                                value={{id: filters?.location_id?.query?.value, label: filters?.location_id?.query?.label}}
                                onChange={(value) => handleSelectDropdownChange('location_id', value)}
                                loadOptions={async (inputValue) => {
                                    
                                    const condition = {
                                        rules: {
                                            condition: 'and',
                                            children: []
                                        }
                                    }
            
                                    const response = await locationService.getList({ search: inputValue }, condition);
                                    return response.data.map(item => ({
                                        id: item.id,
                                        label: item.name?.en+' ('+item.location_number+')',
                                    }));
                                }}
                                actionButtons={[
                                    {
                                        icon: 'fa fa-bars',
                                        label: '',
                                        className: 'btn-primary',
                                        onClick: (value) => locationModal.show()
                                    }
                                ]}
                            />
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('item_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{minWidth: '300px'}}>
                            <CommonAsyncSelect
                                name="item"
                                label="Item"
                                isMulti={true}
                                className="w-100 d-flex flex-column"
                                value={filters?.item_id?.query?.value?.map(item => ({id: item.id, label: item.label}))}
                                onChange={(value) => handleItemsSelectDropdownChange('item_id', value)}
                                loadOptions={async (inputValue) => {
                                    const condition = {
                                        rules: {
                                            condition: 'and',
                                            children: []
                                        }
                                    }
                                    const response = await itemService.getList({ search: inputValue }, condition);
                                    return response.data.map(item => ({
                                        id: item.id,
                                        label: item.name?.en+' ('+item.item_code+')',
                                    }));
                                }}
                                actionButtons={[
                                    {
                                        icon: 'fa fa-bars',
                                        label: '',
                                        className: 'btn-primary',
                                        onClick: (value) => itemModal.show()
                                    }
                                ]}
                            />
                        </div>
                    </div>
                    ) : null
            }
            {
                filters.hasOwnProperty('report_type') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">Report Type</label>
            
                                <div className="bd-example">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="report_type" id="report_type1" checked={filters?.report_type?.query?.value === 'detail'} onChange={() => handleSelectChange('report_type', {'value': 'detail'})}/>
                                        <label className="form-check-label" htmlFor="report_type1">
                                            Detail
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="report_type" id="report_type2" checked={filters?.report_type?.query?.value === 'summary'} onChange={() => handleSelectChange('report_type', {'value': 'summary'})}/>
                                        <label className="form-check-label" htmlFor="report_type2">
                                            Summary
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('job_status') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{minWidth: '200px'}}>
                            <CommonSelect
                                name="job_status"
                                label="Job Status"
                                className="w-100 d-flex flex-column"
                                value={{id: filters?.job_status?.query?.value, label: filters?.job_status?.query?.label}}
                                onChange={(value) => handleSelectDropdownChange('job_status', value)}
                                options={filters?.job_status?.options}
                                placeholder="Select job status..."
                            />
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('branch_id') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2" style={{minWidth: '200px'}}>
                            <CommonSelect
                                name="branch_id"
                                label="Branch"
                                className="w-100 d-flex flex-column"
                                value={{id: filters?.branch_id?.query?.value, label: filters?.branch_id?.query?.label}}
                                onChange={(value) => handleSelectDropdownChange('branch_id', value)}
                                options={filters?.branch_id?.options}
                                placeholder="Select branch..."
                            />
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('status_type') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">Status Type</label>
            
                                <div className="bd-example">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="status_type" id="status_type1" checked={filters?.status_type?.query?.value === '2'} onChange={() => handleSelectChange('status_type', {'value': '2'})}/>
                                        <label className="form-check-label" htmlFor="status_type1">
                                            Walkin
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="status_type" id="status_type2" checked={filters?.status_type?.query?.value === '1'} onChange={() => handleSelectChange('status_type', {'value': '1'})}/>
                                        <label className="form-check-label" htmlFor="status_type2">
                                            LPO
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('job_order_status') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">Job Order Status</label>
            
                                <div className="bd-example">
                                    <div className="form-check form-check">
                                        <input className="form-check-input" type="radio" name="job_order_status" id="job_order_status1" checked={filters?.job_order_status?.query?.value === 'all_job_orders'} onChange={() => handleSelectChange('job_order_status', {'value': 'all_job_orders'})}/>
                                        <label className="form-check-label" htmlFor="job_order_status1">
                                            All Job Orders
                                        </label>
                                    </div>
                                    <div className="form-check form-check">
                                        <input className="form-check-input" type="radio" name="job_order_status" id="job_order_status2" checked={filters?.job_order_status?.query?.value === 'outstanding_job_orders'} onChange={() => handleSelectChange('job_order_status', {'value': 'outstanding_job_orders'})}/>
                                        <label className="form-check-label" htmlFor="job_order_status2">
                                            Outstanding Job Orders
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                filters.hasOwnProperty('delivery_note_status') ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label">Delivery Note Status</label>
            
                                <div className="bd-example">
                                    <div className="form-check form-check">
                                        <input className="form-check-input" type="radio" name="delivery_note_status" id="delivery_note_status1" checked={filters?.delivery_note_status?.query?.value === 'all'} onChange={() => handleSelectChange('delivery_note_status', {'value': 'all'})}/>
                                        <label className="form-check-label" htmlFor="delivery_note_status1">
                                            All
                                        </label>
                                    </div>
                                    <div className="form-check form-check">
                                            <input className="form-check-input" type="radio" name="delivery_note_status" id="delivery_note_status2" checked={filters?.delivery_note_status?.query?.value === 'open'} onChange={() => handleSelectChange('delivery_note_status', {'value': 'open'})}/>
                                        <label className="form-check-label" htmlFor="delivery_note_status2">
                                            Open
                                        </label>
                                    </div>
                                    <div className="form-check form-check">
                                        <input className="form-check-input" type="radio" name="delivery_note_status" id="delivery_note_status3" checked={filters?.delivery_note_status?.query?.value === 'invoiced'} onChange={() => handleSelectChange('delivery_note_status', {'value': 'invoiced'})}/>
                                        <label className="form-check-label" htmlFor="delivery_note_status3">
                                            Invoiced
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }
            {
                (filters && Object.keys(filters).length > 0 && filters?.apply_button) ? (
                    <div className="col-auto">
                        <div className="btn-group me-2">
                            <div className="h-100 d-flex flex-column">
                                <label className="form-label mt-4"></label>
                                <button className="btn btn-primary" onClick={applyClassicFilter}>Apply Filter</button>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            <DataSelectionModal
                show={supplierModal.isVisible}
                onHide={supplierModal.hide}
                title=""
                DataComponent={Suppliers}
                selectionMode="single"
                onDataSelected={handleSupplierSelected}
                componentProps={{
                    // Any props specific to Suppliers component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: supplierExternalCondition
                }}
            />
            <DataSelectionModal
                show={customerModal.isVisible}
                onHide={customerModal.hide}
                title=""
                DataComponent={Customers}
                selectionMode="single"
                onDataSelected={handleCustomerSelected}
                componentProps={{
                    // Any props specific to Customers component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: customerExternalCondition
                }}
            />
            <DataSelectionModal
                show={tailorModal.isVisible}
                onHide={tailorModal.hide}
                title=""
                DataComponent={Tailors}
                selectionMode="single"
                onDataSelected={handleTailorSelected}
                componentProps={{
                    // Any props specific to Tailors component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: tailorExternalCondition
                }}
            />
            <DataSelectionModal
                show={cuttingMasterModal.isVisible}
                onHide={cuttingMasterModal.hide}
                title=""
                DataComponent={Cuttingmasters}
                selectionMode="single"
                onDataSelected={handleCuttingMasterSelected}
                componentProps={{
                    // Any props specific to Tailors component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: cuttingMasterExternalCondition
                }}
            />
            <DataSelectionModal
                show={locationModal.isVisible}
                onHide={locationModal.hide}
                title=""
                DataComponent={Locations}
                selectionMode="single"
                onDataSelected={handleLocationSelected}
                componentProps={{
                    // Any props specific to Tailors component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: locationExternalCondition
                }}
            />
            <DataSelectionModal
                show={itemModal.isVisible}
                onHide={itemModal.hide}
                title=""
                DataComponent={Items}
                selectionMode="multiple"
                onRowsSelected={handleItemSelected}
                componentProps={{
                    // Any props specific to Items component
                    excludedActions: ['create', 'actions', 'filter'],
                    externalCondition: itemExternalCondition,
                    isMultipleSelection: true,
                }}
            />
        </div>
    );
};

export default ClassicFilter;